import api from "./apiConfig";

export const REGISTER_USER = async (data) => {
	try {
		const response = await api.post("/register", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_USERS = async () => {
	try {
		const response = await api.get("/user");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los usuarios:", error);
		throw error;
	}
};

export const GET_USER_ROLE = async (role) => {
	try {
		const response = await api.get(`/user/role/${role}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener usuarios:", error);
		throw error;
	}
};

export const UPDATE_USER = async (id, data) => {
	try {
		const response = await api.put(`/user/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};


export const DELETE_USER = async (id) => {
	try {
		const response = await api.delete(`/user/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};